import {
  getDetails,
  putResource,
  addOneNotification,
  setHideLoader,
  setShowLoader
} from 'src/core/redux/actions';
import { PlateTemplate, Plate } from 'src/models';
import { state as stateConstants } from 'src/constants';
import { selectStateData } from 'src/core/redux/selectors';
import { LOADER_NAMESPACE } from 'src/constants/forms';
import {
  updateReduxFileData
} from 'src/components/OligoDNA/components/UploadPlateTemplate/actions';
import { getErrorMessagesFromResponse } from 'src/utils/api';

import messages from './messages';

export const fetchPlateDetails = (payload) => async (dispatch) => {
  const { plateName } = payload;

  dispatch(setShowLoader(LOADER_NAMESPACE, ''));

  await dispatch(getDetails(Plate)({ plateName }));

  dispatch(setHideLoader(LOADER_NAMESPACE, ''));
};

export const updatePlate = (payload, setEnableActionButtons) => async (dispatch, getState) => {
  const response = await dispatch(putResource(Plate)(payload));
  const { oldPlateName, newPlateName } = payload;

  if (response.status !== 200) {
    const responseData = await response.json();
    const errorMessages = await getErrorMessagesFromResponse(responseData);

    await dispatch(addOneNotification({
      type: 'error',
      message: errorMessages[0],
    }));

    return false;
  }

  await dispatch(addOneNotification({
    type: 'success',
    message: messages.plateNameEditSuccess,
  }));

  setEnableActionButtons(false);

  // update plate name in redux after a success plate edit so when user comes back to upload plate
  // template section plate name is also updated
  const templateData = selectStateData(
    PlateTemplate.NAME,
    stateConstants.IDENTIFIER_TYPE_ITEM
  )(getState()) || {};
  const plateStatuses = templateData?.data?.plateStatuses || [];
  const newPlateStatuses = plateStatuses.map((item) => ({
    ...item,
    plateName: item.plateName === oldPlateName ? newPlateName : item.plateName,
  }));

  dispatch(updateReduxFileData({ plateStatuses: newPlateStatuses }));

  return true;
};
